if (!customElements.get("m-icon-box")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();
      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");
      
      // Array of classes that should show part of next slide on mobile
      this.partialNextSlideClasses = ['athlos-kits-section'];
      
      // Check if this element has any of the special classes
      this.shouldShowPartialNextSlide = this.partialNextSlideClasses.some(className => 
        this.closest(`.${className}`) !== null
      );
    }
    
    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) this.initSlider();
    }
    
    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;
      
      // Check if we're on mobile
      const isMobile = window.innerWidth < 768;
      
      // Only change overflow for special sections on mobile
      if (this.shouldShowPartialNextSlide && isMobile && this.slideContainer) {
        this.slideContainer.style.overflow = "visible";
      }
      
      // Configure Swiper options
      const swiperOptions = {
        slidesPerView: (this.shouldShowPartialNextSlide && isMobile) ? 1.1 : 1,
        spaceBetween: 0,
        navigation: this.showNavigation,
        loop: true,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: (this.shouldShowPartialNextSlide && isMobile) ? 2.1 : 2,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: parseInt(this.items) - 1,
            spaceBetween: 0,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: 0,
          },
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive);
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");
                prevButton.classList.remove("m:hidden");
                nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              
              // Reset overflow on non-mobile breakpoints
              if (swiper.currentBreakpoint === '768' || swiper.currentBreakpoint === '1280') {
                if (this.slideContainer) {
                  this.slideContainer.style.overflow = "";
                }
              }
              
              if (slideItemsLength > Math.floor(slidesPerView)) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
          resize: function() {
            // Reset overflow style on desktop
            if (window.innerWidth >= 768 && __this.slideContainer) {
              __this.slideContainer.style.overflow = "";
            }
            // Apply overflow style on mobile for special sections
            else if (window.innerWidth < 768 && __this.shouldShowPartialNextSlide && __this.slideContainer) {
              __this.slideContainer.style.overflow = "visible";
            }
          }
        },
      };
      
      this.slider = new MinimogLibs.Swiper(this.slideContainer, swiperOptions);
      
      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      
      // Listen for window resize to handle mobile/desktop transitions
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 768 && this.slideContainer) {
          this.slideContainer.style.overflow = ""; // Reset on desktop
        }
        else if (window.innerWidth < 768 && this.shouldShowPartialNextSlide && this.slideContainer) {
          this.slideContainer.style.overflow = "visible"; // Apply on mobile
        }
      });
    }
    
    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }
  customElements.define("m-icon-box", MIconbox);
}